import { DriftType } from "../../../types";

export function getDriftTypeDescription(driftType: DriftType) {
	switch (driftType) {
		case DriftType.A:
			return "Positive Under-reaction";
		case DriftType.B:
			return "Positive Over-reaction";
		case DriftType.C:
			return "Negative Over-reaction";
		case DriftType.D:
			return "Negative Under-reaction";
	}
}
